<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    persistent
    @input="onInput"
  >
    <v-card class="confirm-dialog">
      <h2 class="confirm-dialog__title">{{ title }}</h2>
      <div class="confirm-dialog__body">
        <p v-if="message" class="confirm-dialog__message">{{ message }}</p>
        <slot />
      </div>
      <div class="confirm-dialog__actions">
        <v-btn text @click="onCancel">{{ cancelLabel }}</v-btn>
        <v-btn
          :color="confirmColor"
          :loading="loading"
          :disabled="loading"
          @click="onConfirm"
        >{{ confirmLabel }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, required: true },
    message: { type: String, default: "" },
    confirmLabel: { type: String, default: "Confirm" },
    cancelLabel: { type: String, default: "Cancel" },
    confirmColor: { type: String, default: "primary" },
    loading: { type: Boolean, default: false },
    maxWidth: { type: [Number, String], default: 480 },
  },
  methods: {
    onConfirm() {
      this.$emit("confirm");
    },
    onCancel() {
      this.$emit("cancel");
      this.$emit("input", false);
    },
    onInput(next) {
      if (!next) {
        this.$emit("cancel");
      }
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped lang="scss">
.confirm-dialog {
  padding: 28px 28px 20px;
  border-radius: 12px !important;

  &__title {
    font-size: 20px;
    font-weight: 600;
    color: #0f172a;
    margin: 0 0 12px;
  }

  &__body {
    font-size: 14px;
    line-height: 1.55;
    color: rgba(15, 23, 42, 0.72);
    margin-bottom: 24px;
  }

  &__message {
    margin: 0;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
